const Neo = {
    name: 'NEO',
    options: {
        regexp: '^[0-9]{1}[0-9]{0,11}$',
        numberOfDigits: 12
    }
};

export default Neo;
